import React, { memo, useMemo } from 'react';
import GlobalButton from './GlobalButton';
import './GlobalPagination.css';

const PAGE_SIZES = [10, 20, 50];

const GlobalPagination = ({ meta = {}, tableState = {}, setTableState, mdUp, loading, showOnlyRecords }) => {
  const { totalRecords = 0, totalPages = 0, hasNextPage = false, hasPrevPage = false } = meta;
  const { pageSize = 10, page: currentPage = 1 } = tableState;
  /* ---------- PAGE NUMBERS ---------- */
  const pages = useMemo(() => {
    if (!totalPages || totalPages <= 0) return [];

    if (mdUp && totalPages <= 6) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    //PAGE MORE THAN 6 THEN  SHOW DOTS OTHER WISE 6 PAGE SELCTION PROVIDED INDUVIDUALLY

    // ✅ calculate window
    let start = currentPage - 1;
    let end = currentPage + 1;

    // ✅ shift right if start too small
    if (start < 1) {
      start = 1;
      end = 3;
    }

    // ✅ shift left if end too big
    if (end > totalPages) {
      end = totalPages;
      start = totalPages - 2;
    }
    // ✅ build list
    return Array.from({ length: end - start + 1 }, (_, i) => start + i).filter((n) => n > 0 && n <= totalPages);
  }, [currentPage, totalPages]);

  /* ---------- HANDLERS ---------- */
  const goToPage = (page) => {
    if (page === '…' || page === currentPage) return;
    setTableState((prev) => ({ ...prev, page }));
  };

  const changePageSize = (size) => {
    setTableState((prev) => ({
      ...prev,
      pageSize: size,
      page: 1,
    }));
  };
  const totalLabel = mdUp ? 'Total Records' : 'Total';
  return (
    <div className="pagination-wrapper">
      {/* LEFT */}
      <div className="pagination-left">
        {mdUp && !showOnlyRecords && (
          <select
            disabled={loading}
            className="page-size-select"
            value={pageSize}
            onChange={(e) => changePageSize(Number(e.target.value))}
          >
            {PAGE_SIZES.map((s) => (
              <option key={s} value={s}>
                Limit - {s}
              </option>
            ))}
          </select>
        )}
        <div className="records-chip-wrap">
          <span className="records-chip">
            {totalLabel}: {totalRecords}
          </span>
          {!showOnlyRecords && (
            <span className="records-chip">
              Page: {currentPage}/{totalPages}
            </span>
          )}
        </div>
      </div>

      {/* RIGHT */}
      {!showOnlyRecords && (
        <div className="pagination-right">
          <GlobalButton
            hideIcon={!mdUp}
            size="xs"
            type="previous"
            label="Prev"
            disabled={loading || currentPage === 1 || currentPage == 0 || hasPrevPage == false}
            onClick={() => goToPage(currentPage - 1)}
          />

          {mdUp &&
            !showOnlyRecords &&
            pages.map((p, i) => (
              <button
                disabled={loading}
                key={p}
                className={`page-btn ${p === currentPage ? 'active' : ''}`}
                onClick={() => goToPage(p)}
              >
                {p}
              </button>
            ))}

          <GlobalButton
            hideIcon={!mdUp}
            size="xs"
            type="next"
            label="Next"
            disabled={loading || currentPage === totalPages || hasNextPage == false}
            onClick={() => goToPage(currentPage + 1)}
            iconLast={true}
          />
        </div>
      )}
    </div>
  );
};

export default memo(GlobalPagination);
